// extracted by mini-css-extract-plugin
export default {"select-period-picker":"SelectPeriod_select-period-picker__Lv4pS"};